exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".number-filter{margin-bottom:3px}", "", {"version":3,"sources":["/home/nweibrecht/Dokumente/Akribes/Akribes-App/src/components/plugins/numberFilter.vue"],"names":[],"mappings":"AACA,eACE,iBAAmB,CACpB","file":"numberFilter.vue","sourcesContent":["\n.number-filter {\n  margin-bottom: 3px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f1ac3694","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/plugins/numberFilter.vue
// module id = 931
// module chunks = 0